import { env } from '../config/env';

const technologies = [
  { name: 'React 19', desc: 'The latest version of React with improved performance and new features' },
  { name: 'JavaScript', desc: 'For building interactive user interfaces' },
  { name: 'Redux Toolkit', desc: 'For efficient state management with less boilerplate' },
  { name: 'React Router v7', desc: 'For declarative routing and navigation' },
  { name: 'Custom Design System', desc: 'For a beautiful and consistent UI across all portals' },
  { name: 'Vite', desc: 'For fast development and optimized production builds' },
];

const AboutPage = () => {
  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 600, textAlign: 'center', marginBottom: 24, color: 'var(--ds-text-primary)' }}>
        About {env.appTitle}
      </h1>
      
      <div style={{ padding: 32, maxWidth: 800, margin: '0 auto', border: '1px solid var(--ds-border-default)', borderRadius: 'var(--ds-border-radius-large)', backgroundColor: 'var(--ds-bg-primary)' }}>
        <p style={{ fontSize: '1rem', color: 'var(--ds-text-primary)', marginBottom: 24 }}>
          This is a modern React application built with the latest technologies and best practices.
          It serves as a starting point for building robust, scalable, and maintainable web applications.
        </p>
        
        <hr style={{ border: 'none', borderTop: '1px solid var(--ds-border-default)', margin: '24px 0' }} />
        
        <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: 16, color: 'var(--ds-text-primary)' }}>
          Technologies Used
        </h2>
        
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {technologies.map((t) => (
            <li key={t.name} style={{ padding: '12px 0', borderBottom: '1px solid var(--ds-border-default)' }}>
              <div style={{ fontWeight: 500, color: 'var(--ds-text-primary)' }}>{t.name}</div>
              <div style={{ fontSize: '0.875rem', color: 'var(--ds-text-secondary)', marginTop: 2 }}>{t.desc}</div>
            </li>
          ))}
        </ul>
        
        <hr style={{ border: 'none', borderTop: '1px solid var(--ds-border-default)', margin: '24px 0' }} />
        
        <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: 16, color: 'var(--ds-text-primary)' }}>
          Environment Configuration
        </h2>
        
        <p style={{ fontSize: '1rem', color: 'var(--ds-text-primary)', marginBottom: 12 }}>
          This application supports multiple environments through environment-specific configuration files.
          The current environment is: <strong>{env.appEnv}</strong>
        </p>
        
        <p style={{ fontSize: '0.875rem', color: 'var(--ds-text-secondary)' }}>
          API URL: {env.apiUrl}
        </p>
      </div>
    </div>
  );
};

export default AboutPage;
